import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import SearchByDossierSimpleForm from '../../../components/search/SearchByDossierSimpleForm'
import { translate } from 'react-polyglot'
import { fetchDossierSubTypes, fetchSearchDossierSubType } from '../../../actions/combos/combos'

export function mapStateToProps (state) {
  return {
    combos: {
      dossierSubtypesCombo: state.combos.dossierSubTypesCombo,
      searchDossierSubtypesCombo: state.combos.searchDossierSubtypesCombo
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchDossierSubTypes,
      fetchSearchDossierSubType
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(SearchByDossierSimpleForm))
